/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartPolar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10 2c5.185 0 9.449 3.947 9.95 9H21a1 1 0 0 1 1 1c0 .486-.058 1.3-.23 2.335-.287 1.72-.804 3.44-1.612 5.057A14.42 14.42 0 0 1 18.8 21.6a1 1 0 0 1-1.547.064l-2.732-3.071A7.95 7.95 0 0 1 10 20 8 8 0 0 1 9 4.062V3a1 1 0 0 1 1-1zm9.932 11h-7.705l5.662 6.369.05-.08c.076-.128.15-.258.221-.39l.21-.402c.71-1.422 1.17-2.956 1.427-4.491a17.6 17.6 0 0 0 .128-.922zM9 6.084l-.102.017A6.002 6.002 0 0 0 10 18c1.114 0 2.18-.307 3.106-.872l.072-.047-3.925-4.417-.017-.019a1.005 1.005 0 0 1-.07-.092l-.021-.034a.965.965 0 0 1-.146-.557zm2-2.022V11h6.937l-.03-.226a8.006 8.006 0 0 0-6.681-6.68z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartPolar as ChartPolar };
